// extracted by mini-css-extract-plugin
module.exports = {"info":"footer-module--info--3ISzk","signature":"footer-module--signature--3PPfB","socialMedia":"footer-module--social-media--2PNZQ","icon":"footer-module--icon--3i-HF"};